import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

export const getQuizzes = createSelector(
  (state: RootState) => state.quizzes,
  ({ quizzes }) => quizzes
);

export const getAvailableQuizzes = createSelector(
  (state: RootState) => state.quizzes,
  ({ available }) => available
);

export const getQuizQueue = createSelector(
  (state: RootState) => state.quizzes,
  ({ quizQueue }) => quizQueue
);
